// extracted by mini-css-extract-plugin
module.exports = {"blackOpacity":"blackOpacity_blackOpacity__26UQn","active":"blackOpacity_active__SKnKD"};